/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";

/* Styles */
import styles from "./styles";

const WarningModal = ({showModal, setShowModal, modalIcon, modalTitle, modalDescription}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ modalIcon }
      modalTitle={ modalTitle }
      modalDescription={modalDescription}
      modalFooter={ <Footer setShowModal={setShowModal} /> }
      dataTestId="warningmodal"
    />
  )
};

export default WarningModal;
